import React  from 'react';
import WebPageCardComponent from './account-web-page-cards.components';
import { AccountWebPageBasicInfoComponent } from './account-web-page-basic-info.commponent';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';



export const WebPageComponent = ({onSearch,accounts,handleFormSubmit,back,Id,accountTypes,pages, selectedWebpages,handleInnerFormChange,onDelete,additionButtons,onEdit,rowData,columnDefs}: any) => {
  const tabItems=[
    {
      id:1,
      title:'Basic Information',
      component:<AccountWebPageBasicInfoComponent 
      onInnerFormChange={handleInnerFormChange}
      selectedWebpages ={selectedWebpages} 
      pages={pages}
      accountTypes={accountTypes}
      accounts={accounts}
   />,
      isVisible: Id == 0 ? true : false,
  },
    {
        id:2,
        title:' Web Page Cards ',
        component:<WebPageCardComponent 
        onDelete={onDelete}
        additionButtons={additionButtons}
        rowData={rowData}
        columnDefs={columnDefs}
        onEdit={onEdit}
        onSearch={onSearch}
     />,
     isVisible: Id > 0 ? true : false,
    }
    
  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[520px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
      {Id == 0 ? (
      <div className='flex w-full justify-end items-end'>
     
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>

             
         
               <button
               className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                 onClick={handleFormSubmit}
               
                 type="submit"
             >
               Save
             </button>
        </div>
        ) : null}
       </div>
  )
}
export default WebPageComponent;
